<template>
    <div :class="containerClasses">
        <form method="POST" :action="getFormActionRoute">
            <input type="hidden" name="_token" :value="csrfToken" />
            <input type="hidden" name="email" :value="email" />

            <div class="mb-6 space-y-4">
                <!-- Validation Errors -->
                <slot name="form-errors" />

                <div v-if="successMessage" class="bg-green-50 border border-green-100 text-green-800 rounded text-sm p-4">
                    {{ successMessage }}
                </div>

                <!-- Email (disabled display) -->
                <div>
                    <editable-text-field
                        for-attribute="email_placeholder"
                        :class="[
                            'block text-sm opacity-80 mb-1.5',
                            textColorClass
                        ]"
                        text-type="label"
                        v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_email"
                    />
                    <input
                        type="email"
                        id="email_placeholder"
                        name="email_placeholder"
                        :value="email"
                        disabled
                        required
                        :class="portalContentAndDesignStore.getInputStyle"
                    />
                </div>

                <!-- OTP Token -->
                <div>
                    <editable-text-field
                        for-attribute="token"
                        :class="[
                            'block text-sm opacity-80 mb-1.5',
                            textColorClass
                        ]"
                        text-type="label"
                        :model-value="otpLabelText"
                        @update:model-value="updateOtpLabel"
                    />
                    <otp-input
                        :model-value="oldToken"
                        name="token"
                        id="token"
                        :length="5"
                        :input-classes="portalContentAndDesignStore.getInputStyle"
                        required
                        @enter="handleEnter"
                    />
                </div>
            </div>

            <!-- Submit -->
            <editable-btn
                button-type="submit"
                :prevent-double-click="5000"
                size="huge"
                class="w-full"
                :type="portalContentAndDesignStore.getPageContentButtonColorClass"
                :corners="portalContentAndDesignStore.getPublicPageButtonCorners"
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_login"
            />
        </form>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import {usePortalContentAndDesignStore} from "../../../../../../stores/partners/portalContentAndDesignStore";
import EditableBtn from "../../../../portal-editable-fields/EditableBtn.vue";
import EditableTextField from "../../../../portal-editable-fields/EditableTextField.vue";
import OtpInput from "./OtpInput.vue";


const props = defineProps({
    csrfToken: String,
    email: String,
    oldToken: String,
    successMessage: String,
});

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const getFormActionRoute = () => {
    return route('partners.login.otp.login');
};

const textColorClass = computed(() =>
    portalContentAndDesignStore.getPageContentTextColorClass
);

const containerClasses = computed(() => {
    const settings = portalContentAndDesignStore.portalLayoutSettings;
    const layout = settings.public_page_content_layout;
    const sidebar = settings.portal_login_sidebar_side;
    const sidebarWidth = settings.portal_login_sidebar_width;
    const image = portalContentAndDesignStore.srcRoutes.public_page_background_image;

    const style = [];
    if (layout === 'one') {
        style.push(portalContentAndDesignStore.getPageBackgroundColorClass, 'rounded');
        if (image && sidebar === 'none') {
            style.push('px-10', 'py-10');
        }
    } else if (layout === 'two' || layout === 'three') {
        style.push(portalContentAndDesignStore.getPageContentBackgroundColorClass);
        if (settings.public_page_content_layout_style === 'shadow') {
            style.push('shadow-[0_0_16px_rgba(0,0,0,0.08)]');
        } else if (settings.public_page_content_layout_style === 'border') {
            style.push('border');
        }
        if (settings.public_page_content_layout_corners !== 'none') {
            style.push(settings.public_page_content_layout_corners);
        }
        if (sidebarWidth === 'lg:w-8/12') {
            style.push('px-14', 'py-20');
        } else if (sidebarWidth === 'lg:w-6/12') {
            style.push('px-12', 'py-14');
        } else {
            style.push('px-10', 'py-10');
        }
    }

    return style.join(' ');
});

// OTP label with fallback
const otpLabelText = computed(() => {
    return portalContentAndDesignStore.translationSettings.portal_translation_login_OTP || 'One-time password';
});

const updateOtpLabel = (value) => {
    portalContentAndDesignStore.translationSettings.portal_translation_login_OTP = value;
};

const handleEnter = () => {
    // Submit form when Enter is pressed and OTP is complete
    const form = document.querySelector('form[method="POST"]');
    if (form) {
        form.submit();
    }
};
</script>
